/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления моделями устройства
 */

/**
 * Список возможностей
 */
export enum ModelCapabilityType {
  /**
   * Значение не указано
   */
  CAPABILITY_TYPE_UNKNOWN = "CAPABILITY_TYPE_UNKNOWN",
  /**
   * Возможность смены пароля
   */
  CHANGE_PASSWORD = "CHANGE_PASSWORD",
  /**
   * DTMF коды
   */
  DTMF_CODE = "DTMF_CODE",
  /**
   * Поддержка квартирного автосбора
   */
  FLAT_AUTOCOLLECT = "FLAT_AUTOCOLLECT",
  /**
   * Поддержка звонков
   */
  SIP_CALL = "SIP_CALL",
  /**
   * Поддержка реконфигурирования устройства
   */
  REINSTALL = "REINSTALL",
  /**
   * Аварийное открытие двери
   */
  EMERGENCY_DOOR = "EMERGENCY_DOOR",
  /**
   * Поддержка бегущей строки
   */
  TICKER = "TICKER",
  /**
   * Вызов на номер консьержа
   */
  CONCIERGE_CALL = "CONCIERGE_CALL",
  /**
   * Поддержка умного автосбора
   */
  AUTOCOLLECT = "AUTOCOLLECT",
  /**
   * Временные ключи
   */
  TEMPORARY_KEY = "TEMPORARY_KEY",
  /**
   * Открытие двери
   */
  OPEN_DOOR = "OPEN_DOOR",
  /**
   * Поддержка калитки
   */
  GATE = "GATE",
  /**
   * SIP видео вызов
   */
  SIP_VIDEO = "SIP_VIDEO",
  /**
   * Постоянные ключи
   */
  CONSTANT_KEY = "CONSTANT_KEY",
  /**
   * Поддержка аналоговых трубок
   */
  CMS_PHONES = "CMS_PHONES",
  /**
   * Поддержка шифрования ключей SL3
   */
  SL3 = "SL3",
  /**
   * Поддержка стандарта Syslog
   */
  SYSLOG = "SYSLOG",
  /**
   * Поддержка протокола NTP
   */
  NTP = "NTP",
  /**
   * Распознавание лиц
   */
  FACE_RECOGNITION = "FACE_RECOGNITION",
  /**
   * Видеокамера
   */
  CAMERA = "CAMERA",
  /**
   * Вызов экстренной службы
   */
  EMERGENCY_CALL = "EMERGENCY_CALL",
}
/**
 * Список возможностей
 */
export type ModelCapabilityTypeResponseEnum = keyof typeof ModelCapabilityType
/**
 * Список возможностей
 */
export type ModelCapabilityTypeRequestEnum = Exclude<ModelCapabilityTypeResponseEnum, "CAPABILITY_TYPE_UNKNOWN">;

/**
 * Модель устройства
 */
export type ModelRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
}
/**
 * Модель устройства
 */
export type ModelResponseDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Модель устройства
   */
  "Model": {
    "kind": "class",
    "text": "Модель устройства",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
    },
  },
  /**
   * Список возможностей
   */
  "Model.CapabilityType": {
    "kind": "enum",
    "text": "Список возможностей",
    "values": {
      /**
       * Значение не указано
       */
      "CAPABILITY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Возможность смены пароля
       */
      "CHANGE_PASSWORD": {
        "i": 1,
        "text": "Возможность смены пароля",
      },
      /**
       * DTMF коды
       */
      "DTMF_CODE": {
        "i": 2,
        "text": "DTMF коды",
      },
      /**
       * Поддержка квартирного автосбора
       */
      "FLAT_AUTOCOLLECT": {
        "i": 3,
        "text": "Поддержка квартирного автосбора",
      },
      /**
       * Поддержка звонков
       */
      "SIP_CALL": {
        "i": 4,
        "text": "Поддержка звонков",
      },
      /**
       * Поддержка реконфигурирования устройства
       */
      "REINSTALL": {
        "i": 5,
        "text": "Поддержка реконфигурирования устройства",
      },
      /**
       * Аварийное открытие двери
       */
      "EMERGENCY_DOOR": {
        "i": 6,
        "text": "Аварийное открытие двери",
      },
      /**
       * Поддержка бегущей строки
       */
      "TICKER": {
        "i": 7,
        "text": "Поддержка бегущей строки",
      },
      /**
       * Вызов на номер консьержа
       */
      "CONCIERGE_CALL": {
        "i": 8,
        "text": "Вызов на номер консьержа",
      },
      /**
       * Поддержка умного автосбора
       */
      "AUTOCOLLECT": {
        "i": 9,
        "text": "Поддержка умного автосбора",
      },
      /**
       * Временные ключи
       */
      "TEMPORARY_KEY": {
        "i": 10,
        "text": "Временные ключи",
      },
      /**
       * Открытие двери
       */
      "OPEN_DOOR": {
        "i": 11,
        "text": "Открытие двери",
      },
      /**
       * Поддержка калитки
       */
      "GATE": {
        "i": 12,
        "text": "Поддержка калитки",
      },
      /**
       * SIP видео вызов
       */
      "SIP_VIDEO": {
        "i": 13,
        "text": "SIP видео вызов",
      },
      /**
       * Постоянные ключи
       */
      "CONSTANT_KEY": {
        "i": 14,
        "text": "Постоянные ключи",
      },
      /**
       * Поддержка аналоговых трубок
       */
      "CMS_PHONES": {
        "i": 15,
        "text": "Поддержка аналоговых трубок",
      },
      /**
       * Поддержка шифрования ключей SL3
       */
      "SL3": {
        "i": 16,
        "text": "Поддержка шифрования ключей SL3",
      },
      /**
       * Поддержка стандарта Syslog
       */
      "SYSLOG": {
        "i": 17,
        "text": "Поддержка стандарта Syslog",
      },
      /**
       * Поддержка протокола NTP
       */
      "NTP": {
        "i": 18,
        "text": "Поддержка протокола NTP",
      },
      /**
       * Распознавание лиц
       */
      "FACE_RECOGNITION": {
        "i": 19,
        "text": "Распознавание лиц",
      },
      /**
       * Видеокамера
       */
      "CAMERA": {
        "i": 20,
        "text": "Видеокамера",
      },
      /**
       * Вызов экстренной службы
       */
      "EMERGENCY_CALL": {
        "i": 21,
        "text": "Вызов экстренной службы",
      },
    },
  },
}